import { Image } from '@storybook';

export const UserAvatar = () => {
	return (
		<Image fileName={'AvatarDefault-Light.svg'} className="overlap-image" />
	);
};
